/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool


//sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,



//redesign this component to look more elegant and polished and accents
// and add a little more pizzaz to the menu items and add hover effects 
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy



import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GiCheckMark } from 'react-icons/gi';
import {
    FaRegUser, FaRegEnvelope, FaPhoneAlt, FaBell, } from 'react-icons/fa';
import { HiOutlineIdentification } from 'react-icons/hi';

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { customer_update, messageClear } from '../../store/reducers/authReducer';
import MultiSelectDropdown from '../MultiSelectDropdown';
import GetSellerConfig from '../GetSellerConfig';

import toast from 'react-hot-toast';
import config from '../../config';

// ─── Field wrapper with icon accent ──────────────────────────────────────────
const FieldRow = ({ label, icon: Icon, children, primaryColor }) => (
    <div className="flex flex-col gap-1 mb-4">
        <label className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest"
            style={{ color: primaryColor + 'cc' }}>
            {Icon && <Icon size={12} />}
            {label}
        </label>
        {children}
    </div>
);

// ─── Card ─────────────────────────────────────────────────────────────────────
const ProfileCard = ({ title, icon: Icon, children, colors, wide = false }) => {
    const { bg, text, border, primaryColor, suffixLight, suffixMedium, suffixDark } = colors;

    return (
        <div
            className={`
                relative flex flex-col
                ${wide ? 'w-[340px]' : 'w-[300px]'}
                rounded-2xl border
                transition-all duration-300
                hover:shadow-xl
                overflow-hidden
                m-2
            `}
            style={{
                //backgroundColor: primaryColor + suffixLight,
                borderColor: primaryColor + suffixDark,
                borderTopWidth: '6px',
                //boxShadow: `0 4px 24px 0 ${primaryColor}14`,
            }}>
            {/* Subtle top accent bar */}
            <div
                className="h-[3px] w-full"
                style={{
                    //background: `linear-gradient(90deg, ${primaryColor + suffixMedium}, ${primaryColor + suffixLight})`,
                }}
            />

            {/* Card header */}
            <div
                className="flex items-center gap-2 px-5 pt-3 pb-3"
                style={{ borderBottom: `1px solid ${primaryColor}${suffixDark}` }}>
                {Icon && (
                    <div
                        className="p-1.5 rounded-lg"
                        style={{ backgroundColor: primaryColor + suffixLight }}>
                        <Icon size={20} style={{ color: primaryColor }} />
                    </div>
                )}
                <span className="text-base font-bold tracking-tight" style={{ color: text }}>
                    {title}
                </span>
            </div>

            <div className="px-5 py-4 flex-1">{children}</div>
        </div>
    );
};

// ─── Shared input class ───────────────────────────────────────────────────────
// Tailwind handles the base; focus ring is injected via style below
const inputBase =
    'w-full px-3 py-2 rounded-lg border text-sm text-gray-800 bg-white outline-none transition-all duration-200';

const StyledInput = ({ primaryColor, suffixLight, ...props }) => (
    <input
        {...props}
        className={inputBase}
        style={{
            borderColor: '#e5e7eb',
        }}
        onFocus={e => {
            e.target.style.borderColor = primaryColor;
            e.target.style.boxShadow = `0 0 0 3px ${primaryColor + suffixLight}`;
        }}
        onBlur={e => {
            e.target.style.borderColor = '#e5e7eb';
            e.target.style.boxShadow = 'none';
        }}
    />
);

// ─── Submit button ────────────────────────────────────────────────────────────
const SubmitButton = ({ label, fullWidth = false, loader, primaryColor, suffixDark, suffixLight }) => (
    <button
        type="submit"
        disabled={loader}
        className={`
            ${fullWidth ? 'w-full' : 'px-6'}
            mt-1 py-2.5 rounded-xl text-white text-sm font-semibold
            transition-all duration-200
            disabled:opacity-50 disabled:cursor-not-allowed
            active:scale-[0.98]
        `}
        style={{
            background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor + suffixDark})`,
            //boxShadow: `0 4px 14px 0 ${primaryColor + '55'}`,
        }}
        onMouseEnter={e => {
            //if (!loader) e.currentTarget.style.boxShadow = `0 6px 20px 0 ${primaryColor + suffixLight}`;
        }}
        onMouseLeave={e => {
            //e.currentTarget.style.boxShadow = `0 4px 14px 0 ${primaryColor + '55'}`;
        }}>
        {loader ? (
            <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                </svg>
                Saving…
            </span>
        ) : label}
    </button>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const MyProfile = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;
    const sellerArrMessagingPreferences = config.STR_ARR_MESSAGING_PREFERENCES;

    const { userInfo, loader, errorMessage, successMessage } = useSelector(state => state.auth);

    const {
        sellerPrimaryColor1, sellerSecondaryColor1, sellerColorSuffixDark,
        sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor, sellerShopName, 
    } = GetSellerConfig();

    const showExtendedProfileInfo = false;
    const dispatch = useDispatch();

    const colors = {
        bg: sellerComponentBackgroundColor || sellerSecondaryColor1,
        text: sellerPrimaryColor1,
        border: sellerPrimaryColor1,
        primaryColor: sellerPrimaryColor1,
        suffixDark: sellerColorSuffixDark,
        suffixMedium: sellerColorSuffixMedium,
        suffixLight: sellerColorSuffixLight,
    };

    // ── Form state ──────────────────────────────────────────────────────────
    const [name, setName] = useState(userInfo.name ?? '');
    const [myPhoneNumber, setMyPhoneNumber] = useState(userInfo.phoneNumber ?? '');
    const [selectedItems, setSelectedItems] = useState(() => {
        try { return JSON.parse(userInfo?.messagingPreferences) ?? []; }
        catch { return []; }
    });

    // ── Toast on redux messages ─────────────────────────────────────────────
    useEffect(() => {
        if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
        if (errorMessage)   { toast.error(errorMessage);   dispatch(messageClear()); }
    }, [successMessage, errorMessage]);

    const handleUpdateBasicInfo = (e) => {
        e.preventDefault();
        dispatch(customer_update({
            customerId: userInfo.id,
            name,
            phoneNumber: myPhoneNumber,
            messagingPreferences: JSON.stringify(selectedItems),
        }));
    };

    const handleUpdateMessagingPrefs = (e) => {
        e.preventDefault();
        dispatch(customer_update({
            customerId: userInfo.id,
            name,
            phoneNumber: myPhoneNumber,
            messagingPreferences: JSON.stringify(selectedItems),
        }));
    };

    return (
        <div className="bg-white rounded-2xl">
            <div className="p-4 rounded-2xl"
                style={{
                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                    border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                    //boxShadow: `0 8px 32px 0 ${sellerPrimaryColor1}0f`,
                }}>
                {/* ── Page header ──────────────────────────────────────────── */}
                <div className="flex items-center gap-2 mb-1 pb-0"
                    style={{ borderBottom: `0px solid ${sellerPrimaryColor1}${sellerColorSuffixMedium}` }}>
                    <div>
                        <FaRegUser size={44} style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                    </div>
                    <div>
                        <div
                            className="text-2xl font-bold tracking-tight leading-none"
                            style={{ color: sellerPrimaryColor1 }}>
                            My Profile
                        </div>
                        <div className="text-md mt-0.5" style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                            Manage your personal information
                        </div>
                    </div>
                </div>

                {/* ── Cards ────────────────────────────────────────────────── */}
                <div className="flex flex-wrap items-start">

                    {/* Basic Info */}
                    <ProfileCard title="Basic Info" icon={HiOutlineIdentification} colors={colors}>
                        <form onSubmit={handleUpdateBasicInfo}>
                            <FieldRow label="Full Name" icon={FaRegUser} primaryColor={sellerPrimaryColor1}>
                                <StyledInput
                                    id="name"
                                    type="text"
                                    placeholder="Your name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    primaryColor={sellerPrimaryColor1}
                                    suffixLight={sellerColorSuffixLight}
                                />
                            </FieldRow>

                            <FieldRow label="Phone Number" icon={FaPhoneAlt} primaryColor={sellerPrimaryColor1}>
                                <div
                                    className="w-full px-3 py-2 rounded-lg border text-sm bg-white transition-all duration-200"
                                    style={{ borderColor: '#e5e7eb' }}
                                    onFocusCapture={e => {
                                        e.currentTarget.style.borderColor = sellerPrimaryColor1;
                                        e.currentTarget.style.boxShadow = `0 0 0 3px ${sellerPrimaryColor1 + sellerColorSuffixLight}`;
                                    }}
                                    onBlurCapture={e => {
                                        e.currentTarget.style.borderColor = '#e5e7eb';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}>
                                    <PhoneInput
                                        required
                                        id="phoneNumber"
                                        defaultCountry="US"
                                        value={myPhoneNumber}
                                        onChange={setMyPhoneNumber}
                                        className="outline-none w-full text-sm text-gray-800"
                                        style={{ '--PhoneInput-color--focus': sellerPrimaryColor1 }}
                                    />
                                </div>
                            </FieldRow>

                            <SubmitButton
                                label="Update Basic Info"
                                loader={loader}
                                primaryColor={sellerPrimaryColor1}
                                suffixDark={sellerColorSuffixDark}
                                suffixLight={sellerColorSuffixLight}
                            />
                        </form>
                    </ProfileCard>

                    {/* Messaging Preferences */}
                    <ProfileCard title="Messaging Preferences" icon={FaBell} colors={colors} wide={showExtendedProfileInfo}>
                        <div className="text-sm font-medium mb-4" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            How can <span className="font-semibold" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            {sellerShopName}</span> 
                            connect with you?
                        </div>

                        <form onSubmit={handleUpdateMessagingPrefs}>
                            <FieldRow label="Preferences" icon={FaRegEnvelope} primaryColor={sellerPrimaryColor1}>
                                <MultiSelectDropdown
                                    items={sellerArrMessagingPreferences}
                                    initialSelectedItems={selectedItems}
                                    onSelectionChange={setSelectedItems}
                                    title="Select Messaging Preferences"
                                />
                            </FieldRow>

                            {/* Selected summary */}
                            <div
                                className="rounded-xl p-3 mb-4"
                                style={{
                                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                    border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                                }}>
                                <p className="text-xs font-semibold uppercase tracking-widest mb-2"
                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    Selected Preferences
                                </p>
                                {selectedItems.length > 0 ? (
                                    <ul className="space-y-1.5">
                                        {selectedItems.map((item) => (
                                            <li
                                                key={item.id}
                                                className="flex items-center justify-between px-2 py-1 rounded-lg transition-colors duration-150"
                                                style={{ 
                                                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight, 
                                                }}>
                                                <span className="text-sm font-medium" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                    {item.name}
                                                </span>
                                                <GiCheckMark
                                                    className="w-3.5 h-3.5 flex-shrink-0"
                                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-xs italic" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        No preferences selected yet.
                                    </p>
                                )}
                            </div>

                            {/* Extended SMS consent */}
                            {showExtendedProfileInfo && (
                                <div className="mt-3 space-y-2">
                                    {[
                                        {
                                            name: 'smsConsent',
                                            text: `I want to receive ${sellerShopName} SMS text messages. By checking this box you consent to receive texts for notifications and alerts. Reply STOP to opt out. Message and data rates may apply.`,
                                        },
                                        {
                                            name: 'termsConsent',
                                            text: null, // rendered inline below
                                        },
                                    ].map((item, idx) => (
                                        <label
                                            key={item.name}
                                            className="flex items-start gap-2 p-3 rounded-xl border cursor-pointer transition-colors duration-150"
                                            style={{
                                                borderColor: sellerPrimaryColor1 + '33',
                                                backgroundColor: sellerPrimaryColor1 + '08',
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = sellerPrimaryColor1 + '14'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = sellerPrimaryColor1 + '08'}>
                                            <input
                                                type="checkbox"
                                                name={item.name}
                                                className="mt-0.5 w-4 h-4 rounded border-gray-300 shrink-0"
                                                style={{ accentColor: sellerPrimaryColor1 }}
                                            />
                                            <span className="text-xs leading-relaxed" style={{ color: sellerPrimaryColor1 + 'cc' }}>
                                                {idx === 0 ? item.text : (
                                                    <>
                                                        I agree to the{' '}
                                                        <a href="/terms" className="underline font-medium" style={{ color: sellerPrimaryColor1 }}>Terms and Conditions</a>
                                                        {' '}and the{' '}
                                                        <a href="/privacy" className="underline font-medium" style={{ color: sellerPrimaryColor1 }}>Privacy Policy</a>.
                                                        {' '}Your mobile information will not be sold or shared with third parties for promotional purposes.
                                                    </>
                                                )}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            )}

                            <SubmitButton
                                label="Update Preferences"
                                fullWidth
                                loader={loader}
                                primaryColor={sellerPrimaryColor1}
                                suffixDark={sellerColorSuffixDark}
                                suffixLight={sellerColorSuffixLight}
                            />
                        </form>
                    </ProfileCard>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;




//refactored
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { GiCheckMark } from "react-icons/gi";
// import { FaRegUser } from 'react-icons/fa';

// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css';

// import { customer_update, messageClear } from '../../store/reducers/authReducer';

// import MultiSelectDropdown from '../MultiSelectDropdown';
// import GetSellerConfig from '../GetSellerConfig';

// import toast from 'react-hot-toast';
// import config from '../../config';

// // ─── Reusable card wrapper ────────────────────────────────────────────────────
// const ProfileCard = ({ title, children, wide = false, colors }) => {
//     const { bg, text, border } = colors;
//     return (
//         <div
//             className={`p-4 m-1 rounded-md border-2 ${wide ? 'w-[320px]' : 'w-[280px]'}`}
//             style={{ backgroundColor: bg, color: text, borderColor: border }}
//         >
//             <div className="text-xl font-bold mb-3" style={{ color: text }}>
//                 {title}
//             </div>
//             {children}
//         </div>
//     );
// };

// // ─── Shared input styles ──────────────────────────────────────────────────────
// const inputClass = 'outline-none w-full px-3 py-1 border rounded-md text-gray-800';

// const MyProfile = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const sellerArrMessagingPreferences = config.STR_ARR_MESSAGING_PREFERENCES;

//     const { userInfo, loader, errorMessage, successMessage } = useSelector(state => state.auth);

//     const {
//         sellerPrimaryColor1,
//         sellerSecondaryColor1,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerShopName,
//     } = GetSellerConfig();

//     const showExtendedProfileInfo = false;

//     const dispatch = useDispatch();

//     const colors = {
//         bg: sellerSecondaryColor1,
//         text: sellerPrimaryColor1,
//         border: sellerPrimaryColor1,
//     };

//     // ── Form state ──────────────────────────────────────────────────────────
//     const [name, setName] = useState(userInfo.name ?? '');
//     const [myPhoneNumber, setMyPhoneNumber] = useState(userInfo.phoneNumber ?? '');
//     const [selectedItems, setSelectedItems] = useState(() => {
//         try {
//             return JSON.parse(userInfo?.messagingPreferences) ?? [];
//         } catch {
//             return [];
//         }
//     });

//     // ── Toast on redux messages ─────────────────────────────────────────────
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage]);

//     // ── Submit handlers ─────────────────────────────────────────────────────
//     const handleUpdateBasicInfo = (e) => {
//         e.preventDefault();
//         dispatch(customer_update({
//             customerId: userInfo.id,
//             name,
//             phoneNumber: myPhoneNumber,
//             messagingPreferences: JSON.stringify(selectedItems),
//         }));
//     };

//     const handleUpdateMessagingPrefs = (e) => {
//         e.preventDefault();
//         dispatch(customer_update({
//             customerId: userInfo.id,
//             name,
//             phoneNumber: myPhoneNumber,
//             messagingPreferences: JSON.stringify(selectedItems),
//         }));
//     };

//     // ── Submit button ───────────────────────────────────────────────────────
//     const SubmitButton = ({ label, fullWidth = false }) => (
//         <button
//             type="submit"
//             disabled={loader}
//             className={`${fullWidth ? 'w-full' : 'px-8'} py-2 mt-2 shadow-lg hover:shadow-green-500/30 
//                 text-white rounded-md disabled:opacity-60 disabled:cursor-not-allowed transition-opacity`}
//             style={{ backgroundColor: sellerPrimaryColor1 }}
//         >
//             {loader ? 'Saving…' : label}
//         </button>
//     );

//     return (
//         <div
//             className="p-4 rounded-2xl border"
//             style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}
//         >
//             {/* Header */}
//             <div className="text-2xl flex font-bold gap-2 mb-4 items-center">
//                 <FaRegUser size={24} />
//                 My Profile
//             </div>

//             {/* Cards — wrap naturally on smaller screens */}
//             <div className="flex flex-wrap items-start">

//                 {/* ── Basic Info ─────────────────────────────────────────── */}
//                 <ProfileCard title="Basic Info" colors={colors}>
//                     <form onSubmit={handleUpdateBasicInfo}>
//                         <div className="flex flex-col gap-1 mb-3">
//                             <label htmlFor="name" className="text-sm font-medium">Name</label>
//                             <input
//                                 id="name"
//                                 type="text"
//                                 name="name"
//                                 placeholder="Name"
//                                 value={name}
//                                 onChange={(e) => setName(e.target.value)}
//                                 className={inputClass}
//                             />
//                         </div>
//                         <div className="flex flex-col gap-1 mb-4">
//                             <label htmlFor="phoneNumber" className="text-sm font-medium">Phone Number</label>
//                             <PhoneInput
//                                 required
//                                 id="phoneNumber"
//                                 defaultCountry="US"
//                                 value={myPhoneNumber}
//                                 onChange={setMyPhoneNumber}
//                                 className="outline-none px-3 py-1 border rounded-md w-full"
//                             />
//                         </div>
//                         <SubmitButton label="Update Basic Info" />
//                     </form>
//                 </ProfileCard>

//                 {/* ── Messaging Preferences ──────────────────────────────── */}
//                 <ProfileCard title="Messaging Preferences" wide={showExtendedProfileInfo} colors={colors}>
//                     <p className="text-[15px] font-semibold mb-2">
//                         How Can {sellerShopName} Connect With You?
//                     </p>

//                     <form onSubmit={handleUpdateMessagingPrefs}>
//                         <MultiSelectDropdown
//                             items={sellerArrMessagingPreferences}
//                             initialSelectedItems={selectedItems}
//                             onSelectionChange={setSelectedItems}
//                             title="Select Messaging Preferences"
//                         />

//                         {/* Selected items summary */}
//                         <div
//                             className="mt-2 p-2 bg-gray-50 border border-gray-200 rounded-md"
//                             style={{ color: sellerPrimaryColor1 }}
//                         >
//                             <p className="text-[14px] font-semibold mb-1">Selected:</p>
//                             {selectedItems.length > 0 ? (
//                                 <ul className="space-y-1">
//                                     {selectedItems.map((item) => (
//                                         <li
//                                             key={item.id}
//                                             className="flex items-center justify-between px-1 py-0"
//                                         >
//                                             <span className="text-[14px]" style={{ color: sellerPrimaryColor1 }}>
//                                                 {item.name}
//                                             </span>
//                                             <GiCheckMark className="w-4 h-4 text-green-500" />
//                                         </li>
//                                     ))}
//                                 </ul>
//                             ) : (
//                                 <p className="italic text-[13px] text-gray-500">
//                                     No preferences selected.
//                                 </p>
//                             )}
//                         </div>

//                         {/* Extended SMS consent — only shown when flag is true */}
//                         {showExtendedProfileInfo && (
//                             <div className="mt-3 space-y-2">
//                                 <label className="flex items-start gap-2 border border-gray-600 p-2 rounded-md cursor-pointer">
//                                     <input
//                                         type="checkbox"
//                                         name="smsConsent"
//                                         className="mt-1 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 shrink-0"
//                                     />
//                                     <span className="text-[13px]">
//                                         I want to receive {sellerShopName} SMS text messages. By checking this box
//                                         you consent to receive texts for notifications and alerts. Reply STOP to opt out.
//                                         Message and data rates may apply.
//                                     </span>
//                                 </label>
//                                 <label className="flex items-start gap-2 border border-gray-600 p-2 rounded-md cursor-pointer">
//                                     <input
//                                         type="checkbox"
//                                         name="termsConsent"
//                                         className="mt-1 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 shrink-0"
//                                     />
//                                     <span className="text-[13px]">
//                                         I agree to the{' '}
//                                         <a href="/terms" className="text-blue-600 underline">Terms and Conditions</a>
//                                         {' '}and the{' '}
//                                         <a href="/privacy" className="text-blue-600 underline">Privacy Policy</a>.
//                                         Your mobile information will not be sold or shared with third parties for promotional purposes.
//                                     </span>
//                                 </label>
//                             </div>
//                         )}

//                         <SubmitButton label="Update Messaging Preferences" fullWidth />
//                     </form>
//                 </ProfileCard>

//             </div>
//         </div>
//     );
// };

// export default MyProfile;



//my original code
// import React, { useEffect, useState } from 'react';
// import {  useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { GiCheckMark } from "react-icons/gi";
// import { FaRegUser } from 'react-icons/fa';

// import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
// import 'react-phone-number-input/style.css'

// import { customer_update, messageClear } from '../../store/reducers/authReducer';

// import MultiSelectDropdown from '../MultiSelectDropdown';
// import GetSellerConfig from '../GetSellerConfig';

// import toast from 'react-hot-toast';

// import config from '../../config';
    
// const MyProfile = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const sellerArrMessagingPreferences = config.STR_ARR_MESSAGING_PREFERENCES

//     const { userInfo, loader, errorMessage, successMessage  } = useSelector(state => state.auth);
//     //const { seller } = useSelector(state => state.seller)

//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerShopName, 
//     } = GetSellerConfig();

//     const showExtendedProfileInfo = false 

//     const navigate = useNavigate();        
//     const dispatch = useDispatch();
    
//     let [state, setState] = useState({
//         webSiteOrigin: sellerFrontendURL, 
//         name: userInfo.name, 
//         phoneNumber: userInfo.phoneNumber,
//         email: userInfo.email, //, password: ''
//         messagingPreferences: userInfo.messagingPreferences
//     })
    
//     const [myPhoneNumber, setMyPhoneNumber] = useState(state.phoneNumber)
//     const [selectedItems, setSelectedItems] = useState(JSON.parse(userInfo?.messagingPreferences));
//     //const [selectedItems, setSelectedItems] = useState([]);
    
//     const inputHandle = (e) => {
//         setState({
//             ...state, 
//             [e.target.name] : e.target.value
//         })
//     }

//     const customer_update_local = (e) => {
//         e.preventDefault()
//         //console.log(userInfo.id)
//         const obj = {
//             customerId: userInfo.id,
//             name: state.name, 
//             phoneNumber: myPhoneNumber,
//             messagingPreferences: JSON.stringify(selectedItems), //selectedItems
//         }
//         dispatch(customer_update(obj))
//     }
    
//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <div className='p-4 rounded-2xl border'
//             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//             <div className='text-2xl flex font-bold  gap-1 mb-2 '>
//                 <FaRegUser size={26} className='' /> My Profile
//             </div>
//             {
//                 //pl-2 w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2
//                 //grid grid-cols-2 gap-2 mb-2  w-[620px]
//             }

//             <div className="">
//                 <h2 className="hidden text-xl font-semibold mb-4">Reverse Responsive Table Layout</h2>
//                 <p className="hidden mb-4">Resize screen: Side-by-side on small, stacked on large.</p>
//                 {/*  min-w-full */}
//                 <table className=" border-collapse border-none border-gray-700">
//                     <thead>
//                         <tr className='hidden' >
//                             <th className="border border-gray-300 p-2">Header 1</th>
//                             <th className="border border-gray-300 p-2">Header 2</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                     {/* Key here: Default is table-row, but we override at 'lg' breakpoint */}
//                         <tr className="table-row lg:flex lg:flex-col">
//                             {/* On small screens, these TDs are normal table cells (side-by-side) */}
//                             {/* On large screens (lg:), they become blocks and stack */}
//                             <td className="align-top border-none border-gray-700 table-cell lg:block">
//                                 <div className='p-4 m-1 rounded-md border-2 w-[280px]' 
//                                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className='text-xl font-bold flex flex-col gap-1 mb-2 '>
//                                         Basic Info
//                                     </div>
//                                     <form onSubmit={customer_update_local} >
//                                         <div className='flex flex-col gap-1 mb-2'>
//                                             <label htmlFor="name">Name</label>
//                                             <input onChange={inputHandle} value={state.name} type="text" name="name" id="name" placeholder='Name'
//                                                 className='outline-none w-52 px-3 py-1 border rounded-md' />
//                                         </div>
//                                         <div className='flex flex-col gap-1 mb-2'>
//                                             <label htmlFor="phoneNumber">Phone Number</label>
//                                             {   
//                                                 //onChange={setMyPhoneNumber} value={myPhoneNumber}
//                                                 //hidden
//                                                 //formatPhoneNumber(value) back readable
//                                                 //{formatPhoneNumber(currentCustomer.phoneNumber)}
//                                                 // <PhoneInput onChange={setMyPhoneNumber} value={myPhoneNumber} defaultCountry='US' country="US" 
//                                                 // className='outline-none px-3 w-80 py-1 border rounded-md' />
//                                             }
//                                             <PhoneInput required onChange={setMyPhoneNumber} value={myPhoneNumber} defaultCountry='US' country="US" 
//                                                 className='outline-none px-3 w-52 py-1 border rounded-md' />
//                                             <input onChange={inputHandle} value={state.phoneNumber} 
//                                                 type="text" name="phoneNumber" id="phoneNumber" placeholder='Phone Number'
//                                                 className='hidden outline-none px-3 w-52 py-1 border rounded-md' />
//                                         </div>
//                                         <div>
//                                             <button className='px-8 py-2 shadow-lg hover:shadow-green-500/30 text-white rounded-md' 
//                                                 style={{backgroundColor:sellerPrimaryColor1}}>
//                                                 Update Basic Info
//                                             </button>
//                                         </div>
//                                     </form>
//                                 </div>
//                             </td>
//                             <td className="align-top border-none border-gray-700 table-cell lg:block">
//                                 <div className={` ${showExtendedProfileInfo ? 'w-[480px]' : 'w-[280px]' } p-4 m-1 rounded-md border-2 `} 
//                                     style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                     <div className='text-xl font-bold flex flex-col mb-0 ' style={{color:sellerPrimaryColor1}}>
//                                         Messaging Preferences
//                                     </div>
//                                     <div className='text-[15px] font-bold flex flex-col ml-1 ' style={{color:sellerPrimaryColor1}}>
//                                         How Can {sellerShopName} Connect With You?
//                                         <span className='hidden text-[15px] font-normal'>(Select all that apply)</span>
//                                     </div>
//                                     <form onSubmit={customer_update_local}>
//                                         <MultiSelectDropdown items={sellerArrMessagingPreferences} initialSelectedItems={selectedItems} 
//                                             onSelectionChange={setSelectedItems} title="Select Messaging Preferences" />
//                                         <div className="p-2 bg-gray-50 border border-gray-200 rounded-md" style={{color:sellerPrimaryColor1}}>
//                                             <div className="text-[14px] font-semibold mb-0">
//                                                 Selected Messaging Preferences:
//                                             </div>
//                                             {selectedItems.length > 0 ? (
//                                                 <ul className=" space-y-1">
//                                                     {selectedItems.map((item) => (
//                                                         <li key={item.id} className="flex items-center justify-between w-full 
//                                                             px-1 py-0 text-left border-none" style={{borderColor:sellerPrimaryColor1}}>
//                                                             <span className="font-normal text-[14px]" style={{color:sellerPrimaryColor1}}>
//                                                                 {item.name}
//                                                             </span>
//                                                             <GiCheckMark className="w-5 h-5 text-green-500 inline-block" /> 
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                                 ) : (
//                                                     <p className="italic font-normal text-[13px]">No Messaging Preferences Selected.</p>
//                                                 )}
//                                             </div>
//                                             <div className={` ${showExtendedProfileInfo ? '' : 'hidden'} 
//                                                 w-full flex items-center gap-2 mb-2 border border-gray-600 p-2 rounded-md`}>
//                                                <input  
//                                                     className='w-20 h-20 text-blue-600 overflow-hidden bg-gray-200 rounded border-gray-300 focus:ring-blue-500' 
//                                                     type="checkbox" name="newsletterSignUp" id="newsletterSignUp" />
//                                                 <span className='text-[13px]'> 
//                                                     I Want To Receive {sellerShopName} SMS Text Messages
//                                                     By checking this box and clicking “SEND” you consent to receive text messages for notifications 
//                                                     and alerts from {sellerShopName}. Reply STOP to opt out. Reply HELP for help. Message and data 
//                                                     rates may apply. Message frequency may vary.
//                                                 </span> 
//                                             </div>
//                                             <div className={` ${showExtendedProfileInfo ? '' : 'hidden'} 
//                                                 mt-2 w-full flex items-center gap-2 mb-2 border border-gray-600 p-2 rounded-md`}>
//                                                <input  
//                                                     className='w-16 h-16 text-blue-600 overflow-hidden bg-gray-200 rounded border-gray-300 focus:ring-blue-500' 
//                                                     type="checkbox" name="newsletterSignUp" id="newsletterSignUp" />
//                                                 <span className='text-[13px]'> 
//                                                     I Can Reply Stop SMS Text Messages To OPT Out At Anytime
//                                                     I agree to the <a href='#' className='text-blue-600 underline'>Terms and Conditions</a> and the 
//                                                     <a href='#' className='text-blue-600 underline'> Privacy Policy</a>.
//                                                     Your mobile information will not be sold or shared with third parties for 
//                                                     promotional purposes.
//                                                 </span> 
//                                                 {
                                                    
//                                                     // I Can Reply Stop SMS Text Messages To OPT Out At Anytime
//                                                     // I agree to the Terms and Conditions (Link) and Privacy Policy (Link).
//                                                     // Your mobile information will not be sold or shared with third parties for 
//                                                     // promotional purposes.
//                                                 }
//                                             </div>
//                                             <div>
//                                                 <button className='w-full px-2 py-2 mt-2 shadow-lg hover:shadow-green-500/30 text-white rounded-md' 
//                                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                                     Update Messaging Preferences
//                                                 </button>
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </td>

//                                 <td className="align-top border-none border-gray-700 table-cell lg:block">
//                                     <div className='hidden p-4 m-1 rounded-md border-2 w-[280px]' 
//                                         style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className='text-xl font-bold flex flex-col mb-2 ' style={{color:sellerPrimaryColor1}}>
//                                             Change Password
//                                         </div>
//                                         <form>
//                                             <div className='flex flex-col gap-1 mb-2'>
//                                                 <label htmlFor="old_password">Old Password</label>
//                                                 <input className='outline-none px-3 py-1 w-60 border rounded-md' type="password" name="old_password" id="old_password"  placeholder='Old Password'/>
//                                             </div>
//                                             <div className='flex flex-col gap-1 mb-2'>
//                                                 <label htmlFor="new_password">New Password</label>
//                                                 <input className='outline-none px-3 py-1 w-60 border rounded-md' type="password" name="new_password" id="new_password"  placeholder='New Password'/>
//                                             </div>
//                                             <div className='flex flex-col gap-1 mb-2'>
//                                                 <label htmlFor="confirm_password">Confirm Password</label>
//                                                 <input className='outline-none px-3 py-1 w-60 border rounded-md' type="password" name="confirm_password" id="confirm_password"  placeholder='Confirm Password'/>
//                                             </div>
//                                             <div>
//                                                 <button className='px-8 py-2 shadow-lg hover:shadow-green-500/30 text-white rounded-md' 
//                                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                                     Update Password
//                                                 </button>
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </td>
//                             </tr>
//                         </tbody>
//                     </table>
//                 </div>
//         </div>
//     );
// };

// export default MyProfile;






/*
const EditForm = () => {
    // Initialize state for the form fields
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: ''
    });

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Data Submitted:', formData);
        // Here you can add code to handle the submitted data
    };

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>Name:</label>
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    required
                />
            </div>
            <div>
                <label>Email:</label>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                />
            </div>
            <div>
                <label>Password:</label>
                <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    required
                />
            </div>
            <button type="submit">Submit</button>
        </form>
    );
};

export default EditForm;

*/
